import { buttonVariants } from "@anthra/ui/button-variants"
import { cn } from "@anthra/ui/cn"
import { type QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"

import { NotFoundDenied } from "@/components/not-found-denied"

/**
 * The root route. Everything renders inside this Outlet.
 *
 * `createRootRouteWithContext` types the router context, so `queryClient` is
 * available and typed in every route below.
 */
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
	component: RootLayout,
	notFoundComponent: NotFound,
})

function RootLayout() {
	return <Outlet />
}

/**
 * A route the router cannot resolve at all — against the design's one
 * dead-end (screens/not-found-denied.html), the same shell the panel uses for
 * a missing query, a missing vetting request, and a role that cannot reach
 * expert-management.
 */
function NotFound() {
	return (
		<NotFoundDenied
			standalone
			eyebrow="Not found"
			title="Page not found"
			lede="That link does not point anywhere in the panel any more."
			actions={
				<a
					className={cn(buttonVariants({ variant: "primary" }))}
					href="/"
				>
					Go to the dashboard
				</a>
			}
		/>
	)
}
